import axios from 'axios';
const API_URL = '/api/devis'; // Remplace par l'URL de ton backend
export const createDevis = async (devisData) => {
  const response = await axios.post(API_URL, devisData);
  return response.data;
};
